import { Injectable } from '@angular/core';
import { UserDto, UserService } from '@api-client';
import { patchState, signalState } from '@ngrx/signals';

type UserState = {
  user: UserDto | null;
};

@Injectable({ providedIn: 'root' })
export class UserAuthStore {
  private readonly state = signalState<UserState>({
    user: null,
  });

  constructor(private readonly userService: UserService) {
    this.fetchUser();
  }

  readonly user = this.state.user;

  setUser(user: UserDto | null) {
    patchState(this.state, { user });
  }

  async fetchUser() {
    return new Promise<void>((resolve, reject) => {
      this.userService.userControllerMe().subscribe({
        next: (user) => {
          this.setUser(user);
          resolve();
        },
        error: () => {
          this.setUser(null);
          reject();
        },
      });
    });
  }
}
